// extracted by mini-css-extract-plugin
export var desktopOnly = "StickySlides-module--desktopOnly--NPWJ0";
export var mobileOnly = "StickySlides-module--mobileOnly--2XDc6";
export var observer = "StickySlides-module--observer--xE7Vk";
export var slidesWrapper = "StickySlides-module--slidesWrapper--Rn2dG";
export var wrapper = "StickySlides-module--wrapper--d2WmK";